import {
  getCoursePurchaseDetails,
  purchaseCourse,
  getMyPurchases
} from '@/api/purchase.api'

import {
  getInvoiceStatus
} from '@/api/invoice.api'

const state = {
  isProcessingPayment: false,
  isPaymentFailed: false,
  isPaymentSuccessful: false,
  purchaseCourseDetails: { user: {} },
  myPurchases: []
}

const mutations = {
  setProcessingPayment (state, status) {
    state.isProcessingPayment = status
  },
  setPaymentSuccessFul (state, status) {
    state.isPaymentSuccessful = status
  },
  setPaymentFailed (state, status) {
    state.isPaymentFailed = status
  },
  setPurchaseCourseDetails (state, details) {
    state.purchaseCourseDetails = details
  },
  setMyPurchases (state, purchases) {
    state.myPurchases = purchases
  }
}

const getters = {
  purchaseCourseDetails ({ purchaseCourseDetails }) {
    return purchaseCourseDetails
  },
  isProcessingPayment ({ isProcessingPayment }) {
    return isProcessingPayment
  },
  isPaymentSuccessful ({ isPaymentSuccessful }) {
    return isPaymentSuccessful
  },
  isPaymentFailed ({ isPaymentFailed }) {
    return isPaymentFailed
  },
  myPurchases ({ myPurchases }) {
    return myPurchases
  }
}

const actions = {
  async fetchMyPurchases ({ commit }) {
    const purchases = await getMyPurchases()
    commit('setMyPurchases', purchases)
  },

  async fetchCoursePurchaseDetails ({ commit }, courseId) {
    const response = await getCoursePurchaseDetails(courseId)

    if (!response.success) {
      return false
    }

    commit('setPurchaseCourseDetails', response.data.course)
    commit('payment/setPaymentDetails', response.data.payment, { root: true })
    commit('payment/setPaymentInstallmentsAvailable', response.data.installments, { root: true })

    return true
  },

  async boletoPurchase ({ getters }, data) {
    const course = getters.purchaseCourseDetails

    const res = await purchaseCourse(course.id, {
      cpf: data.cpf
    })

    return res
  },

  async purchaseCourse ({ getters, rootGetters }) {
    return new Promise(async(resolve) => {
      const course = getters.purchaseCourseDetails
      const paymentDetails = rootGetters['payment/paymentDataChargeDetails']

      const purchase = await purchaseCourse(course.id, {
        card_hash: paymentDetails.card_hash,
        cpf: paymentDetails.cpf,
        installments: paymentDetails.installments
      })

      const interval = setInterval(async() => {
        const invoiceStatus = await getInvoiceStatus(purchase.invoice.id)

        if (!invoiceStatus.isPaid && !invoiceStatus.isFailed) {
          return
        }

        clearInterval(interval)
        resolve({
          success: invoiceStatus.isPaid,
          invoice: purchase.invoice
        })
      }, 2000)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
